import { getServices } from '../../../infra/startup';
import ThemeInterface from './ThemeInterface';
import { ThemeInterfaceType } from '@clientos/types';

export { createNoopThemeInterface } from './NoopInterface';

let themeInterface: ThemeInterface;

export function getThemeInterface(): ThemeInterface {
  return themeInterface;
}

export default async function initializeThemeInterface(): Promise<ThemeInterfaceType> {
  if (themeInterface) return themeInterface.getInterface();

  themeInterface = new ThemeInterface();

  return themeInterface.getInterface();
}
